module.exports = __webpack_public_path__ + "img/9ne.02961994.svg";